module.exports = __webpack_public_path__ + "img/putonghuyuan.3a96c158.png";